import { render, staticRenderFns } from "./ScrollableTable.vue?vue&type=template&id=1053e2a2&scoped=true&"
import script from "./ScrollableTable.vue?vue&type=script&lang=js&"
export * from "./ScrollableTable.vue?vue&type=script&lang=js&"
import style0 from "./ScrollableTable.vue?vue&type=style&index=0&id=1053e2a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1053e2a2",
  null
  
)

export default component.exports